/**
 * AlmadarPostAgenticSearchENPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostAgenticSearchENPostPage
 */

import { useAlmadarPostAgenticSearchENPostPageLogic } from '@/hooks/traits/useAlmadarPostAgenticSearchENPostPageLogic';
import type { AlmadarPostAgenticSearchENPostPageConfig } from '@/hooks/traits/useAlmadarPostAgenticSearchENPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostAgenticSearchENPostView as AlmadarPostAgenticSearchENPostViewEntity } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { AlmadarPostAgenticSearchENPostHeaderView } from '@/components/traits/AlmadarPostAgenticSearchENPostHeaderView';
import { AlmadarPostAgenticSearchENPostView } from '@/components/traits/AlmadarPostAgenticSearchENPostView';
import { AlmadarPostAgenticSearchENPostFooterView } from '@/components/traits/AlmadarPostAgenticSearchENPostFooterView';
import { Container } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostAgenticSearchENPostPageViewProps {
  config?: Partial<AlmadarPostAgenticSearchENPostPageConfig>;
}

export function AlmadarPostAgenticSearchENPostPageView({ config: propsConfig }: AlmadarPostAgenticSearchENPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostAgenticSearchENPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostAgenticSearchENPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostAgenticSearchEN" trait="AlmadarPostAgenticSearchENPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostAgenticSearchENPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostAgenticSearchENPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box fullWidth={true} paddingY="xl" bg="transparent"><Container size="xl" maxWidth="xl" padding="lg"><AlmadarPostAgenticSearchENPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostAgenticSearchENPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostAgenticSearchENPostPageView;
